import { CloseOutlined } from "@mui/icons-material";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { findCurrency, formatNumber } from "../../../../../utils";
import * as PropTypes from "prop-types";
import { useSelector } from "react-redux";
export default function FeeComponent(props) {
  const { feeStructure, withdrawData, setOpen } = props;
  const account = useSelector(({ Auth }) => Auth?.account);
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        width: {
          sm: "100%",
          md: 350,
        },
      }}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          color={"#F8F8F8"}
          textTransform={"capitalize"}
          fontSize={18}
        >
          {t("feeBreakdown")}
        </Typography>
        <IconButton onClick={() => setOpen(false)}>
          <CloseOutlined style={{ color: "#F8F8F8" }} />
        </IconButton>
      </Box>
      <Grid container paddingLeft={1} paddingRight={1}>
        <Grid item xs={12}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            marginBottom={1}
          >
            <Typography
              color={"#F8F8F8"}
              textTransform={"capitalize"}
              fontSize={15}
            >
              {t("totalFees")}
            </Typography>
            <Typography
              color={"#F8F8F8"}
              textTransform={"capitalize"}
              fontSize={15}
            >
              {formatNumber(feeStructure?.totalFeeUsd)} {feeStructure?.currency || findCurrency(account)}
            </Typography>
          </Box>
          {(feeStructure?.fee || feeStructure?.feePercent) && (
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              marginBottom={1}
            >
              <Typography
                color={"#F8F8F8"}
                textTransform={"capitalize"}
                fontSize={13}
              >
                {t("Processing Fee")}
              </Typography>
              <Typography
                color={"#F8F8F8"}
                textTransform={"capitalize"}
                fontSize={13}
              >
                {feeStructure?.fee ? `${feeStructure?.fee} ` : ""}{" "}
                {feeStructure?.fee ? `${feeStructure?.currency || findCurrency(account)}` : ""}
                &nbsp;{feeStructure?.fee ? `+` : ""}&nbsp;
                {parseFloat(feeStructure?.feePercent.toString())
                  ? `${feeStructure?.feePercent}%`
                  : ""}{" "}
              </Typography>
            </Box>
          )}
          {!!(withdrawData?.swapFee || feeStructure?.swapFee) && (
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              marginBottom={1}
            >
              <Typography
                color={"#F8F8F8"}
                textTransform={"capitalize"}
                fontSize={13}
              >
                {t("Swap Fee")}
              </Typography>
              <Typography
                color={"#F8F8F8"}
                textTransform={"capitalize"}
                fontSize={13}
              >
                {formatNumber(withdrawData?.swapFee || feeStructure?.swapFee)}{" "}
                {feeStructure?.currency || findCurrency(account)}
              </Typography>
            </Box>
          )}
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            marginBottom={1}
          >
            <Typography
              color={"#F8F8F8"}
              textTransform={"capitalize"}
              fontSize={13}
            >
              {t("networkFee")}
            </Typography>
            <Typography
              color={"#F8F8F8"}
              textTransform={"capitalize"}
              fontSize={13}
            >
              {formatNumber(
                withdrawData?.localNetworkFee || feeStructure?.localNetworkFee
              )}{" "}
              {feeStructure?.currency || findCurrency(account)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

FeeComponent.propTypes = {
  feeStructure: PropTypes.object,
  withdrawData: PropTypes.object,
  setOpen: PropTypes.func,
};
